import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from '@apollo/client';
import { makeDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import * as t from 'io-ts';
export var useLanguages = makeDecodedQuery(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query Languages {\n      languages {\n        id\n        name\n        displayName\n        code\n      }\n    }\n  "]))), t.type({
  languages: t.array(t.type({
    id: t.string,
    name: t.string,
    displayName: t.string,
    code: t.string
  }))
}));